import * as modalVideo from '../../../node_modules/modal-video/js/jquery-modal-video';

if ($('.js-modal-video').length > 0) {
  $('.js-modal-video').modalVideo({
    channel:'youtube',
    youtube: {
      autoplay: 1,
      controls: 1
    }
  });
}
